module.exports = __webpack_public_path__ + "static/media/user-profile.6ddbdf14.svg";